import get from 'lodash/get';
import { getIsCartItemsAvailable } from 'cart/actions/cartAvailable';

/**
 * Action to dispatch edit cart to update fulfillment time and
 * it calls getIsCartItemAvailable if we have items in our cart to
 * determine if cart items are available
 */
const verifyCartItemsStillFulfillable = () => async (dispatch, getState) => {
  const state = getState();
  const { cart, cartWorkingCopy } = state;
  const currentItems = get(cart, 'items', []);

  if (currentItems.length > 0) {
    return dispatch(getIsCartItemsAvailable(cartWorkingCopy));
  }
};

export default verifyCartItemsStillFulfillable;
